export default "__VITE_ASSET__CeXeKdi$__"